var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.20766 2.53574C8.11904 2.36994 7.88135 2.36994 7.79274 2.53575L2.07035 13.2421C1.9866 13.3989 2.10014 13.5883 2.27781 13.5883H13.7225C13.9003 13.5883 14.0138 13.3989 13.93 13.2421L8.20766 2.53574ZM6.54799 1.87044C7.16831 0.709853 8.83209 0.709851 9.45241 1.87044L15.1748 12.5769C15.7611 13.6737 14.9663 14.9997 13.7225 14.9997H2.27781C1.03409 14.9997 0.239339 13.6737 0.8256 12.5769L6.54799 1.87044ZM8.94113 11.236C8.94113 11.7556 8.51987 12.1769 8.0002 12.1769C7.48055 12.1769 7.05927 11.7556 7.05927 11.236C7.05927 10.7163 7.48055 10.295 8.0002 10.295C8.51987 10.295 8.94113 10.7163 8.94113 11.236ZM8.7059 6.29608C8.7059 5.90634 8.38994 5.59038 8.0002 5.59038C7.61046 5.59038 7.2945 5.90634 7.2945 6.29608V8.6484C7.2945 9.03814 7.61046 9.3541 8.0002 9.3541C8.38994 9.3541 8.7059 9.03814 8.7059 8.6484V6.29608Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.4bdd84aa0354a0d23cb5fa8a042c93aa.svg";
export { ForwardRef as ReactComponent };